export const ThemeActionTypes = {
    SET_THEME_COLOR: 'theme/SET_THEME_COLOR',
    SET_TINT_COLOR: 'theme/SET_TINT_COLOR',
    SET_IS_MOBILE: 'theme/SET_IS_MOBILE',
    SET_IS_SEMI_MOBILE: 'theme/SET_IS_SEMI_MOBILE',
}